import { useTranslations } from 'next-intl';
import type { RatingGridChoice, RatingGridResult } from './types';

interface ScreenReaderTableProps {
  results: RatingGridResult[];
  choices: RatingGridChoice[];
  shouldHideResults: boolean;
  range: { min: number; max: number };
  xAxisLabel: string;
  yAxisLabel: string;
}

export const ScreenReaderTable = ({
  results,
  choices,
  xAxisLabel,
  yAxisLabel,
  range,
  shouldHideResults,
}: ScreenReaderTableProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('option_column_title')}</th>
          <th scope="col">
            {translate('rating_average_result_column_title', {
              dimension: xAxisLabel,
              min: `${range.min}`,
              max: `${range.max}`,
            })}
          </th>
          <th scope="col">
            {translate('rating_average_result_column_title', {
              dimension: yAxisLabel,
              min: `${range.min}`,
              max: `${range.max}`,
            })}
          </th>
        </tr>
      </thead>
      <tbody>
        {choices.map((choice) => {
          const result = results.find((r) => r.id === choice.id);
          return (
            <tr key={choice.id}>
              <th scope="row">{choice.label}</th>
              {result ? (
                <>
                  <td>{result.average.x.toFixed(1)}</td>
                  <td>{result.average.y.toFixed(1)}</td>
                </>
              ) : (
                <>
                  <td></td>
                  <td></td>
                </>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
